import React from "react";
import Contact from './Contact'
export default function ContactApp(){
    return(
        <>
        <Contact/>
        </>
    )
}